import { createContext } from "react";

export const EstimateEditorSettingsContext = createContext({});
